import { Pencil1Icon, TrashIcon } from '@radix-ui/react-icons';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { ConfirmAlertDialog } from '../../../components/common/ConfirmAlertDialog';
import { Lists } from '../../../components/common/Lists';
import TableComponent from '../../../components/common/Tables';
import { useAppDispatch } from '../../../hooks/hooks';
import { useGetLoansQuery } from '../../../hooks/library/useGetLoansQuery';
import { setLoanData } from '../../../redux/slices/library/loan';
import { routes } from '../../../routes';
import { updateLoan } from '../../../services/library/loan';
import { LoanType } from '../../../types/Library';
import { key_loans } from '../../../utils/constants';

const columnNamesMap: { [key: string]: string } = {
    bookTitle:"Livro",
    userFullname:"Utilizador",
    loanDate:"Data de Empréstimo",
    dueDate:"Data prevista",
    returnedDate:"Data de Devolução",
  //  daysDelayed:"Dias de atraso",
};

export const Loans = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteItem, setDeleteItem] = useState<LoanType | null>(null);
    const [returnItem, setReturnItem] = useState<LoanType | null>(null);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const { data, status } = useGetLoansQuery({ PageNumber: currentPage, PageSize: 10 });
    const mutationUpdate = useMutation(updateLoan, {
        onSuccess: () => {
            queryClient.invalidateQueries(key_loans);
            toast.success('Empréstimo actualizado');
        },
        onError: () => {
            toast.error("Erro ao actualizar Empréstimo")
        }
    });
    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createLoan);
    }
    const handleDelete = (c: LoanType) => {
        c.status = false;
        mutationUpdate.mutateAsync(c)
      };
    const handleReturnItem = (c: LoanType) => {
        c.returnedDate = new Date().toISOString();
        mutationUpdate.mutateAsync(c)
      };
      const openDeleteDialog = (s: LoanType) => {
        setDeleteItem(s);
      };  
      const confirmDelete = async () => {
          if (deleteItem) {
              await handleDelete(deleteItem!)
            }
        };
        const openReturnDialog = (s: LoanType) => {
            if (s.returnedDate) {
                toast.error("Foi devolvido");
                return;
            }
          setReturnItem(s);
        };  
      const confirmReturnItem = async () => {
        if (returnItem) {
            await handleReturnItem(returnItem!)
        }
      };
      const handleEdit = (c: LoanType) => {
        dispatch(setLoanData(c));
        navigate(routes.updateLoan)
      };

      const options = data?.items.map((c: LoanType) => [
        // {
        //     label: 'Editar',
        //     onClick: () => handleEdit(c),
        //     icon: <Pencil1Icon />
        // },
        {
            label: 'Devolução',
            onClick: () => openReturnDialog(c),
            icon: <Pencil1Icon />
        },
        // {
        //     label: 'Ver dados do utilizador',
        //     onClick: () =>{},
        //     icon: <Pencil1Icon />
        // },
        // {
        //     label: 'Excluir',
        //     onClick: () => openDeleteDialog(c),
        //     icon: <TrashIcon />
        // }
      ]) || [];
      return (
        <>
            <Lists
                status={status}
                TableComponent={() =>
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                }
               handleClickCreate={handleClickCreate}
            />
            <ConfirmAlertDialog
                open={!!deleteItem}
                onOpenChange={(open) => !open && setDeleteItem(null)}
                title="Esta operação é irreversível"
                item={deleteItem}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteItem(null)}
            />
            <ConfirmAlertDialog
                open={!!returnItem}
                onOpenChange={(open) => !open && setReturnItem(null)}
                title="(Devolução) Esta operação é irreversível"
                item={returnItem}
                onConfirm={confirmReturnItem}
                onCancel={() => setReturnItem(null)}
            />
        </>
      );
}
